import { StateCreator } from "zustand";

import { StoreMiddlewares } from "../storeTypes";

type AnalyticsEvents = {
  onFinish: () => void;
  onPause: () => void;
  onPlay: () => void;
  onSeekStart: () => void;
  onSeekEnd: () => void;
  onTimeUpdate: (currentTime: number) => void;
};

type SnowplowQuality = {
  bitrate: number;
  newQuality: string;
  framerPerSecond: number;
  automatic: boolean;
};

type SnowplowEvents = AnalyticsEvents & {
  onBufferStart: () => void;
  onBufferEnd: () => void;
  onDestroy: () => void;
  onFullscreenChange: (fullscreen: boolean) => void;
  onPipChange: (pip: boolean) => void;
  onPlaybackRateChange: (newRate: number) => void;
  onQualityChange: (quality: SnowplowQuality) => void;
  onVolumeChange: (newVolume: number) => void;
};

export type AnalyticsSliceState = {
  analyticsEvents: AnalyticsEvents | undefined; // Adobe analytics events
  snowplowEvents: SnowplowEvents | undefined;
  marketingCloudVisitorId: string | undefined;
};

type AnalyticsSliceActions = {
  setAnalyticsEvents: (analyticsEvents: AnalyticsEvents) => void;
  setSnowplowEvents: (analyticsEvents: SnowplowEvents) => void;
  setMarketingCloudVisitorId: (id: string) => void;
};

export type AnalyticsSlice = AnalyticsSliceState & AnalyticsSliceActions;

export const ANALYTICS_SLICE_DEFAULTS: AnalyticsSliceState = {
  analyticsEvents: undefined,
  marketingCloudVisitorId: undefined,
  snowplowEvents: undefined
};

export const analyticsSlice: StateCreator<
  AnalyticsSlice,
  StoreMiddlewares
> = set => ({
  ...ANALYTICS_SLICE_DEFAULTS,
  setAnalyticsEvents: analyticsEvents =>
    set({ analyticsEvents }, false, "setAnalyticsEvents"),
  setMarketingCloudVisitorId: id =>
    set({ marketingCloudVisitorId: id }, false, "setMarketingCloudVisitorId"),
  setSnowplowEvents: snowplowEvents =>
    set({ snowplowEvents }, false, "setSnowplowEvents")
});
